import { shouldTrackUserEvents } from '@repo/utils';
import { Helmet } from 'react-helmet-async';

declare global {
  interface Window {
    clarity: Function;
  }
}

const CLARITY_SCRIPT = `
(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "o43xq56tsf");
`;

export default function ClarityTracking() {
  if (shouldTrackUserEvents()) {
    return (
      <Helmet defer={false}>
        <script type="text/javascript">
          {CLARITY_SCRIPT}
        </script>
      </Helmet>
    );
  } else {
    return null;
  }
}

export function identifyClarityUser(email: string, name: string) {
  if (!shouldTrackUserEvents()) {
    return;
  }
  if (window.clarity && typeof window.clarity === 'function') {
    window.clarity('identify', email, null, null, name);
  }
}
